export default __webpack_public_path__ + "static/media/r4.94967f0f.jpg";